module.exports = __webpack_public_path__ + "img/sm-instagram@2x.03fe4036.png";